

import { Database } from '../db.ts';
import { PremiumLevel } from './premium.ts';

type DBUser = Database['public']['Tables']['users']['Row'];

export type UserProfile = Omit<DBUser, 'profile' | 'permissions' | 'premium_level' | 'stripe' > & {
    profile: UserProfiledData | null;
    permissions: UserPermissions | null;
    premium_level: PremiumLevel;
    stripe: UserStripeData | null;
};

export namespace UserProfile {
    /** Temporary helper to get user email after data structure change */
    export function getEmail(u: UserProfile) {
        return u?.email || u?.profile?.email || null;
    }

    export function getName(u: UserProfile | null | undefined) {
        const profile = u?.profile;
        return profile?.name || profile?.oauth?.name || null;
    }

    export function getPhone(u: UserProfile | null | undefined) {
        const profile = u?.profile;
        return profile?.phone || null;
    }
}

export type UserProfiledData = {
    /** @deprecated use `email` from parent */
    email?: string;

    name?: string;

    phone?: string;

    /** populated from oauth data */
    oauth?: {
        name?: string;
        avatar_url?: string;
    };
};

export type UserStripeData = {
    customerId?: string;
};

export type UserPermissions = {
    canListAllCampaigns?: boolean;
    canListAllUsers?: boolean;
    canListAllProducts?: boolean;
    canListAllPurchases?: boolean;

    canEditAllCampaigns?: boolean;
    canSetPremiumLevel?: boolean;
};

/* all (admin) permissions shortcut

    "canListAllCampaigns": true,
    "canListAllUsers": true,
    "canListAllProducts": true,
    "canListAllPurchases": true,

    "canEditAllCampaigns": true,
    "canSetPremiumLevel": true

*/
